import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { TASK_KEYS } from '@/features/tasks/public';
import { timeTrackingService } from '../api/time-tracking.service';
import { TIME_TRACKING_KEYS } from './queryKeys';

export function useStartTimer() {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);
  const orgId = activeOrganizationId ?? '';

  return useMutation({
    mutationFn: (taskId: string) => timeTrackingService.startTimer(taskId),
    onSuccess: (_data, taskId) => {
      // byOrg covers activeTimer + task/project/user entries consumed by reports
      queryClient.invalidateQueries({ queryKey: TIME_TRACKING_KEYS.byOrg(orgId) });
      queryClient.invalidateQueries({ queryKey: TASK_KEYS.detail(orgId, taskId) });
    },
  });
}

export function useStopTimer() {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);
  const orgId = activeOrganizationId ?? '';

  return useMutation({
    mutationFn: (taskId: string) => timeTrackingService.stopTimer(taskId),
    onSuccess: (_data, taskId) => {
      // byOrg covers activeTimer + task/project/user entries consumed by reports
      queryClient.invalidateQueries({ queryKey: TIME_TRACKING_KEYS.byOrg(orgId) });
      queryClient.invalidateQueries({ queryKey: TASK_KEYS.detail(orgId, taskId) });
    },
  });
}
